import { analytics } from 'Modules/Analytics'

const config = { domain: 'Account', subdomain: 'Team' }

interface AddMemberSubmitted {
  role: string
  accountType: string
  numberOfMembersInvited: number
  inviterAccountType: string
  invitedTeamMemberDate: string
}

interface SpecificTeamMemberAdded {
  accountType: string // user being invited
  email: string // user submitting change
  funderOrgId: number
  invitedTeamMember: string // email address
  invitedTeamMemberDate: string
  inviterAccountType: string
  nonprofitOrgId: number
  platformPlan: string
  role: string // user submitting change
  userStatus: string // 'Invited'
}
interface AccountTypeSelected {
  accountType: string
  updatedUserId: number
}
interface RoleSelected {
  role: string
  updatedUserId: number
}

interface RemoveUserSubmitted {
  userId: number // user submitting change
  email: string // user submitting change
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number
  removedUser: string // email address
  userStatus: string
  role: string
}

interface RemoveUserClicked {
  userId: number // user being removed
  email: string // user being removed
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number
  role: string
}

interface OnboardingSkipClicked {
  userId: number
  email: string
  accountType: string
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number | null
  role: string
  dateSkipped: string
}

interface EditProfileClicked {
  userId: number
  email: string
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number
  role: string
}

interface EditRoleSubmitted {
  userId: number // user submitting change
  email: string // user submitting change
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number
  chosenRole: string
}

interface EditAccountTypeSubmitted {
  userId: number // user submitting change
  email: string // user submitting change
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number
  chosenAccountType: string
}

interface ResendInviteSubmitted {
  accountType: string // user being invited
  email: string // user submitting change
  funderOrgId: number
  invitedTeamMember: string // email address
  invitedTeamMemberDate: string
  userId: number // user submitting change
  inviterAccountType: string
  nonprofitOrgId: number
  platformPlan: string
  role: string // user submitting change
}

interface MemberJoinedResiliaSubmitted {
  userId: number // user submitting change
  email: string // user submitting change
  userFirstName: string
  userLastName: string
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number
  userStatus: string // 'AccountProvisioned'
}

interface InviteOnboardingPageViewed {
  userId: number
  email: string
  nonprofitOrgId: number
  platformPlan: string
  funderOrgId: number
}

export const team = {
  Add_Member_Submitted: {
    Add_Member_Submitted: (param: AddMemberSubmitted) => param,
    config,
  },
  Add_Member_Clicked: {
    Add_Member_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Clicked: {
    Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },

  Account_Type_Selected: {
    Account_Type_Selected: (param: AccountTypeSelected) => param,
    config,
  },

  Role_Selected: {
    Role_Selected: (param: RoleSelected) => param,
    config,
  },
  Remove_User_Submitted: {
    Remove_User_Submitted: (param: RemoveUserSubmitted) => param,
    config,
  },
  Remove_User_Clicked: {
    Remove_User_Clicked: (param: RemoveUserClicked) => param,
    config,
  },
  Onboarding_Skip_Clicked: analytics.trackCreator<OnboardingSkipClicked>({
    ...config,
    eventName: 'Onboarding_Skip_Clicked',
  }),
  Edit_Profile_Clicked: {
    Edit_Profile_Clicked: (param: EditProfileClicked) => param,
    config,
  },
  Edit_Role_Submitted: {
    Edit_Role_Submitted: (param: EditRoleSubmitted) => param,
    config,
  },
  Edit_Account_Type_Submitted: {
    Edit_Account_Type_Submitted: (param: EditAccountTypeSubmitted) => param,
    config,
  },
  Resend_Invite_Submitted: {
    Resend_Invite_Submitted: (param: ResendInviteSubmitted) => param,
    config,
  },
  Member_Joined_Resilia_Submitted: {
    Member_Joined_Resilia_Submitted: (param: MemberJoinedResiliaSubmitted) =>
      param,
    config,
  },
  Specific_Team_Member_Added: {
    Specific_Team_Member_Added: (param: SpecificTeamMemberAdded) => param,
    config,
  },
  Onboarding_Page_Viewed: {
    Onboarding_Page_Viewed: (param: InviteOnboardingPageViewed) => param,
    config,
  },
}
